import { render, staticRenderFns } from "./exchangeRateConfig.vue?vue&type=template&id=a0ceef0c&scoped=true"
import script from "./exchangeRateConfig.vue?vue&type=script&lang=js"
export * from "./exchangeRateConfig.vue?vue&type=script&lang=js"
import style0 from "./exchangeRateConfig.vue?vue&type=style&index=0&id=a0ceef0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ceef0c",
  null
  
)

export default component.exports